<template>
  <el-dialog
    title="编辑账号信息"
    :visible.sync="auth.isShowAccountEditDialog"
    :type="'edit'"
    width="574px"
  >
    <accountCommon ref="account" :data="auth.accountDetail" :type="'edit'" />
    <span slot="footer" class="dialog-footer">
      <el-button @click="goBack()">返回</el-button>
      <el-button type="primary" @click="save()">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import accountCommon from './account-common.vue'
export default {
  components: {
    accountCommon,
  },
  data() {
    return {
      isShowEditAccountDialog: true,
    }
  },
  computed: {
    auth() {
      return this.$store.state.auth
    },
  },
  methods: {
    goBack() {
      this.$store.commit('auth/update', {
        isShowAccountEditDialog: false,
      })
    },
    save() {
      this.$refs.account.submitForm()
    },
  },
}
</script>

<style></style>
